export const MacOsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_17297_154697)">
      <path
        d="M22.0929 17.9897C21.5409 19.2119 21.2769 19.7583 20.5679 20.8383C19.5775 22.3466 18.179 24.2288 16.4501 24.2417C14.9123 24.2546 14.5153 23.2383 12.4283 23.2549C10.3412 23.2651 9.90641 24.2602 8.36672 24.2445C6.6378 24.2288 5.3141 22.5331 4.32272 21.0276C1.55072 16.8045 1.2581 11.8549 2.97133 9.2214C4.18333 7.35401 6.10149 6.2574 7.90241 6.2574C9.73656 6.2574 10.8895 7.2654 12.4061 7.2654C13.8775 7.2654 14.7738 6.25463 16.895 6.25463C18.4993 6.25463 20.1959 7.12878 21.4079 8.63709C17.4424 10.81 18.0867 16.474 22.0929 17.9897ZM15.2852 4.56909C16.0569 3.57863 16.6421 2.18109 16.4298 0.755859C15.1707 0.841706 13.6984 1.64571 12.8381 2.68694C12.059 3.63494 11.4129 5.04355 11.6649 6.40601C13.0384 6.45032 14.4599 5.63155 15.2852 4.56909Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_17297_154697">
        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
)
